export function SendMailIcon() {
  return (
    <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M2.5 4.1665H17.5C18.3284 4.1665 19 4.83812 19 5.6665V14.3332C19 15.1616 18.3284 15.8332 17.5 15.8332H2.5C1.67157 15.8332 1 15.1616 1 14.3332V5.6665C1 4.83812 1.67157 4.1665 2.5 4.1665Z' stroke='#F2C94C' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M1 4.1665L10 10.8332L19 4.1665' stroke='#F2C94C' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  );
}
